import { useProductPlatformInfo } from './useProductInfo'
import { ProductSalesMode } from '@/view-models/product'

export function useProductFlags(_product = ref({})) {
  const product = computed(() => unref(_product))
  const { isBookSeatOnly, isPaidOnsite } = useProductPlatformInfo(product)

  const isDelivery = computed(() => !!product.value.delivery || product.value.sales_mode === ProductSalesMode.Delivery)
  const isCrossDay = computed(() => product.value.is_crossday === 1)
  const isCamping = computed(() => product.value.sales_mode === ProductSalesMode.Camping)
  const isHeadcountOptional = computed(() => product.value.is_cust_num === 1)
  const canGroup = computed(() => !!product.value.can_group)
  const isNeedSeatSelection = computed(() => product.value.is_cust_num === 1 && isBookSeatOnly.value)

  return {
    isDelivery,
    isCrossDay,
    isCamping,
    isHeadcountOptional,
    canGroup,
    isBookSeatOnly,
    isPaidOnsite,
    isNeedSeatSelection,
  }
}
